module.exports = __webpack_public_path__ + "img/自然语言处理.03b49f8c.jpg";